import React from "react";

const MoreSvg = ({ fill }) => {
  return (
    <div className="box">
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.40001 0.799988C1.18783 0.799988 0.98435 0.884273 0.834321 1.0343C0.684292 1.18433 0.600006 1.38781 0.600006 1.59999C0.600006 1.81216 0.684292 2.01564 0.834321 2.16567C0.98435 2.3157 1.18783 2.39999 1.40001 2.39999H20.6C20.8122 2.39999 21.0157 2.3157 21.1657 2.16567C21.3157 2.01564 21.4 1.81216 21.4 1.59999C21.4 1.38781 21.3157 1.18433 21.1657 1.0343C21.0157 0.884273 20.8122 0.799988 20.6 0.799988H1.40001ZM0.600006 7.99999C0.600006 7.78781 0.684292 7.58433 0.834321 7.4343C0.98435 7.28427 1.18783 7.19999 1.40001 7.19999H20.6C20.8122 7.19999 21.0157 7.28427 21.1657 7.4343C21.3157 7.58433 21.4 7.78781 21.4 7.99999C21.4 8.21216 21.3157 8.41564 21.1657 8.56567C21.0157 8.7157 20.8122 8.79999 20.6 8.79999H1.40001C1.18783 8.79999 0.98435 8.7157 0.834321 8.56567C0.684292 8.41564 0.600006 8.21216 0.600006 7.99999ZM0.600006 14.4C0.600006 14.1878 0.684292 13.9843 0.834321 13.8343C0.98435 13.6843 1.18783 13.6 1.40001 13.6H20.6C20.8122 13.6 21.0157 13.6843 21.1657 13.8343C21.3157 13.9843 21.4 14.1878 21.4 14.4C21.4 14.6122 21.3157 14.8156 21.1657 14.9657C21.0157 15.1157 20.8122 15.2 20.6 15.2H1.40001C1.18783 15.2 0.98435 15.1157 0.834321 14.9657C0.684292 14.8156 0.600006 14.6122 0.600006 14.4Z"
          fill={fill}
        />
      </svg>
    </div>
  );
};

export default MoreSvg;
